export default __webpack_public_path__ + "static/media/Chateau-Grey.c23b251c.jpg";